module.exports = __webpack_public_path__ + "img/chat.3be5fdc7.svg";